/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import React, { useCallback } from 'react';
var styles = css({
  maxHeight: 0,
  maxWidth: 0,
  position: 'absolute'
});
export var StopPropagation = function StopPropagation(_ref) {
  var children = _ref.children;
  var onClick = useCallback(function (e) {
    // Prevent click event inside modal from bubble up
    e.stopPropagation();
  }, []);
  return jsx("span", {
    css: styles,
    onClick: onClick
  }, children);
};